import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Input, Row, Form, Col, notification, Button, Divider } from "antd";
import { PlusOutlined, KeyOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { values } from "lodash";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const Change = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [loadingErp, setLoadingErp] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordAgain, setNewPasswordAgain] = useState("");
  const [form] = Form.useForm();
  const [formErp] = Form.useForm();

  useEffect(() => {
    setOldPassword(oldPassword);
    setNewPassword(newPassword);
    setNewPasswordAgain(newPasswordAgain);
    getLogoInfos();
  }, [setOldPassword, setNewPassword, setNewPasswordAgain]);

  const onChangeOldPassword = (e) => {
    setOldPassword(e.target.value);
  };

  const onChangeNewPassword = (e) => {
    setNewPassword(e.target.value);
  };

  const onChangeNewPasswordAgain = (e) => {
    setNewPasswordAgain(e.target.value);
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Şifre güncelleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const openNotificationOldNewPasswordWarning = (type) => {
    notification[type]({
      message: "HATA",
      description: "Girdiğiniz şifreler uyuşmuyor.",
      duration: 2,
    });
  };

  const openNotificationWithErpIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Erp kullanıcı kayıt işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const onFinish = (values) => {
    const hata = values.NewPassword !== values.NewPasswordAgain ? "hata" : null;
    if (hata === "hata") {
      openNotificationOldNewPasswordWarning("error");
      setLoading(false);
    } else {
      RequestHandler.post(
        `/Auth/ChangePassword`,
        {
          oldPassword: values.OldPassword,
          newPassword: values.NewPassword,
          newPasswordAgain: values.newPasswordAgain,
        },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.status == 200) {
          openNotificationWithIcon("success");
          setTimeout(
            function () {
              history.push(`/home`);
            }.bind(this),
            2000
          );
        } else {
          setLoading(false);
        }
      });
    }
  };

  const onFinishErp = (values) => {
    RequestHandler.post(
      `/Auth/UpdateLogoUserInfos`,
      {
        logoUsername: values.logoUserName,
        logoPassword: values.logoPassword,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        openNotificationWithErpIcon("success");
        setTimeout(() => {
          setLoadingErp(false);
          window.location.reload();
        }, 2000);
      } else {
        setLoadingErp(false);
      }
    });
  };

  const getLogoInfos = () => {
    RequestHandler.get(`/TenantUser/GetById`).then((response) => {
      if (response) {
        form.setFieldsValue(response);
        formErp.setFieldsValue(response);
      }
    });
  };

  const onFinishFailed = () => setLoading(false);
  const onFinishErpFailed = () => setLoadingErp(false);

  return (
    <div>
      <Row>
        <Col span={24}>
          <p style={{ fontSize: "200%" }}>
            {" "}
            <KeyOutlined /> ŞİFRE GÜNCELLE
          </p>{" "}
          <hr></hr>
          <br></br>
        </Col>
      </Row>
      <Form
        {...layout}
        name="basic"
        style={{ width: "100%" }}
        initialValues={{
          remember: true,
        }}
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Eski Şifre"
              name="OldPassword"
              rules={[
                {
                  required: true,
                  message: "Lütfen eski şifre alanını boş bırakmayın.",
                },
              ]}
            >
              <Input
                type="password"
                onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()}
                value={oldPassword}
                onChange={onChangeOldPassword}
              />
            </Form.Item>
            <Form.Item
              label="Yeni Şifre"
              name="NewPassword"
              rules={[
                {
                  required: true,
                  message: "Lütfen yeni şifre alanını boş bırakmayın.",
                },
              ]}
            >
              <Input
                type="password"
                onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()}
                value={newPassword}
                onChange={onChangeNewPassword}
              />
            </Form.Item>
            <Form.Item
              label="Yeni Şifre Tekrar"
              name="NewPasswordAgain"
              rules={[
                {
                  required: true,
                  message: "Lütfen şifre tekrar alanını boş bırakmayın.",
                },
              ]}
            >
              <Input
                type="password"
                onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()}
                value={newPasswordAgain}
                onChange={onChangeNewPasswordAgain}
              />
            </Form.Item>
          </Col>
          <Col span={16}></Col>
          <Col span={8}>
            <Form.Item {...tailLayout}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Form.Item>
          </Col>
        </Row>


      </Form>
      {/* <Form {...layout}
        name="basic"
        style={{ width: "100%" }}
        initialValues={{
          remember: true,
        }}
        form={formErp}
        onFinish={onFinishErp}
        onFinishFailed={onFinishErpFailed}>
        <Row>
          <Col span={24}>
            <p style={{ fontSize: "200%" }}>
              {" "}
              <KeyOutlined /> ERP KULLANICI BİLGİSİ
            </p>{" "}
            <hr></hr>
            <br></br>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Kullanıcı Adı"
              name="logoUserName"
              rules={[
                {
                  required: true,
                  message: "Lütfen logo kullanıcı adını boş bırakmayın.",
                },
              ]}
            >
              <Input autoComplete="off" />
            </Form.Item>
            <Form.Item
              label="Şifre"
              name="logoPassword"
              rules={[
                {
                  required: true,
                  message: "Lütfen logo şifre alanını boş bırakmayın.",
                },
              ]}
            >
              <Input
                onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()}
              />
            </Form.Item>
          </Col>
          <Col span={16}></Col>
          <Col span={8}>
            <Form.Item {...tailLayout}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => { setLoadingErp(true); }}
                loading={loadingErp}
              >
                Güncelle
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form> */}
    </div>
  );
};
export default Change;
